import React from 'react';
import { ExampleImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { Margin } from '@helpers';
import { getImage } from "gatsby-plugin-image";

export const ImageLanguage = ({getPng, t}) => {
    return (
      <PageWrapper darkMode={false}>
        <Container paddingTop='57px' marginLeft='102px' paddingBottom='88px'>
          <Text width='575px' paddingBefforeText="45px" paddingAffterText="30px" paddingUl="67px">
            <h1>{t("Acceptable image language")}</h1>
            <p>
              {t("Images speak to users in the same way that texts do. Therefore, the images we use in our publications must also meet corporate requirements:")}
            </p>
            <ul>
              <li>
                {t("- there should be no people in the images;")}
              </li>
              <li>
                {t("- images should not contain excessively bright colors;")}
              </li>
              <li>
              {t("- when using images of computer or laptop screens, they should depict the interfaces of Soft-FX products and solutions.")}
              </li>
            </ul>
          </Text>
          <FlexDiv>
            <Margin marginRight="20px">
              <Margin marginBottom='20px'><ExampleImg image={getImage(getPng("example_1"))} alt="example"/></Margin>
              <Margin marginBottom='20px'><ExampleImg image={getImage(getPng("example_3"))} alt="example" /></Margin>
              <Margin marginBottom='20px'><ExampleImg image={getImage(getPng("example_5"))} alt="example" /></Margin>
              <ExampleImg image={getImage(getPng("example_6"))} alt="example" />
            </Margin>
            <div>
            <Margin marginBottom='20px'><ExampleImg image={getImage(getPng("example_2"))} alt="example" /></Margin>
            <Margin marginBottom='20px'><ExampleImg image={getImage(getPng("example_4"))} alt="example" /></Margin>
            <Margin marginBottom='20px'><ExampleImg image={getImage(getPng("example_7"))} alt="example" /></Margin>
              <ExampleImg image={getImage(getPng("example_8"))} alt="example" />
            </div>
          </FlexDiv>
        </Container>
     </PageWrapper>
  );
};
